import React, { Component } from "react";
import * as _ from "lodash";

export interface InputSearchProps {
    searchAction: any;
    items: any;
    selectedFilters: any;
    form?: any;
    field?: any;
    givenid?: string;
    disabled?: boolean;
}

export interface InputSearchState {
    isFocused: boolean;
    searchValue: string;
    id: string;
    label: string;
    value: string;
    notes: string | null;
}

export default class InputSearch extends Component<InputSearchProps, InputSearchState> {
    searchInput: React.RefObject<HTMLInputElement>;

    constructor(props) {
        super(props);
        this.searchInput = React.createRef();
        var value = props.field.value
        var label = ''
        var notes = ''
        if (value !== undefined){
            var filter = props.items.filter((i: { value: any; })=>i.value==value)
            if (filter.length>0) {
                label = filter[0].label
                notes = filter[0].notes
            }
        }
        this.state = {
            isFocused: false,
            searchValue: "",
            id: this.generateUniqueId(),
            label: label,
            value: value,
            notes: notes
        };
    }

    onFocus = () => {
        if (this.props.disabled) return;
        this.setState({
            isFocused: true
        },
            () => this.searchInput.current.focus()
        );
    };

    onBlur = () => {
        this.setState({
            isFocused: false,
            searchValue: ""
        });
    };

    onInput = event => {
        this.setState({
            searchValue: event.target.value
        });
    };

    onChangeHandler = (val) => {
        this.props.form.setFieldValue(this.props.field.name, parseInt(val));
    };

    onSelectItem = event => {
        if (this.props.searchAction ) this.props.searchAction(event.target.getAttribute("data-value"));
        var val = event.target.getAttribute("data-value")
        var notes = event.target.getAttribute("data-notes")
        this.searchInput.current.value = "";
        this.setState({
            searchValue: "",
            isFocused: false,
            label: event.target.innerText,
            value: val,
            notes: notes
        },
            () => this.onChangeHandler(val)
        );
    };

    filterItemInstances = () => {
        let self = this;
        return _.filter(this.props.items, instance => {
            return (
                instance.label
                    .toUpperCase()
                    .includes(self.state.searchValue.toUpperCase())
            );
        });
    };

    componentDidMount() {
        document.addEventListener("click", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("click", this.handleClickOutside);
    }

    handleClickOutside = event => {
        if (!document.querySelector(`#` + this.props.givenid + `_search-items_` + this.state.id).contains(event.target)) {
            // save state
            this.setState({
                isFocused: false,
                searchValue: ""
            });
        }
    };

    generateUniqueId() {
        return Date.now() + '-' + Math.floor(Math.random() * 1000);
    }

    render() {
        const filteteredItemInstances = this.filterItemInstances();
        return (
            <div id={this.props.givenid + "_search-items_" + this.state.id} className="filter-select search-items">
                <div className="group-search-items">
                    <div onClick={this.onFocus}>
                        <div className="value-search-items" >
                            {this.state.label}
                        </div>
                        {this.state.notes && this.state.notes != "" && this.state.notes != 'null' &&
                            (<div className="note-search-items">
                                <b>Notes: </b> {this.state.notes}
                            </div>)
                        }
                    </div>
                    {this.state.isFocused && (
                        <React.Fragment>
                            <input className="input-search-items"
                                   ref={this.searchInput}
                                   onInput={this.onInput}
                                   placeholder="Search"
                            />
                            <div className='icon-search-items'></div>
                        </React.Fragment>)}

                </div>
                {this.state.isFocused && (
                    <div className="search-results">
                        <div>
                            <ul>
                                {this.props.items && (
                                    <React.Fragment>
                                        {filteteredItemInstances.length > 0 &&
                                            filteteredItemInstances.map(
                                                instance => {
                                                    return (
                                                        <li
                                                            onClick={
                                                                this
                                                                    .onSelectItem
                                                            }
                                                            key={instance.value}
                                                            data-value={`${instance.value}`}
                                                            data-notes={`${instance.notes}`}
                                                        >
                                                            {
                                                                instance.label
                                                            }
                                                        </li>
                                                    );
                                                }
                                            )}
                                        {filteteredItemInstances.length ==
                                            0 && <li>No Results</li>}
                                    </React.Fragment>
                                )}
                            </ul>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}